<div class="col-md-12" *ngIf="isLoading">
	<app-busy [message]="message"></app-busy>
</div>

<div class="page_header">
	<h1 class="heading">Carrier Accounts</h1>
</div>

<div class="row" style="display: none;">
	<div style="margin-top:10px; margin-bottom:-10px;">
		<h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b>&nbsp;Approve Carrier Accounts</b>
		</h5>
	</div>
</div>

<app-filter [carrierName]="carrierName" [carrierNumber]="carrierNumber" [selectedItems]="selectedItems"></app-filter>
<fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;display: none;">
	<div class="row" style="margin:15px auto!important;padding-left:100px;">
		<div class="col-3" style="margin:0px!important;padding:0px!important;">
			<input type="text" style="width:280px!important;height:35px" class="form-control form-control-lg pull-right"
				[(ngModel)]="carrierName" placeholder="Filter by carrier name..."
				title="Enter the Carrier name to filter by..." (keypress)="checkKey($event)">
		</div>
		<div class="col-3">
			<input type="text" style="width:210px!important;height:35px" class="form-control form-control-lg"
				[(ngModel)]="carrierNumber" placeholder="Filter by account number..."
				title="Enter the Account number to filter by..." (keypress)="checkKey($event)">
		</div>
		<div class="col-3">
			<input type="text" style="width:210px!important;height:35px" class="form-control form-control-lg"
				[(ngModel)]="first_Name" placeholder="Filter by name..." title="Enter the name to filter by..."
				(keypress)="checkKey($event)">
		</div>
		<div class="col-3">
			<input type="text" style="width:210px!important;height:35px" class="form-control form-control-lg"
				[(ngModel)]="surname" placeholder="Filter by surname..." title="Enter the surname to filter by..."
				(keypress)="checkKey($event)">
		</div>
		<div class="col-3">
			<input type="text" style="width:210px!important;height:35px" class="form-control form-control-lg"
				[(ngModel)]="id_number" placeholder="Filter by ID number..." title="Enter the ID number to filter by..."
				(keypress)="checkKey($event)">
		</div>
		<div class="col-3">
			<input type="text" style="width:210px!important;height:35px" class="form-control form-control-lg"
				[(ngModel)]="companyRegNumber" placeholder="Filter by registration number..."
				title="Enter the registration number to filter by..." (keypress)="checkKey($event)">
		</div>
		<div class="col-4 resizer" style="width:350px; padding:0px" title="Select one or more statuses to filer by...">
			<ng-multiselect-dropdown [placeholder]="'Filter by one or more statuses...'" [data]="statuses"
				[(ngModel)]="selectedItems" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)"
				(onDeSelect)="onDeSelect($event)" (onSelectAll)="onSelectAll($event)">
			</ng-multiselect-dropdown>
		</div>
		<div class="col-2 btn-show" style="width:80px !important; margin:0px!important;padding-top:0px!important;">
			<span (click)="onReset()" id="onResetAccount" title="Reset filters..." class="btn btn-success btn-sm pull-right"><i
					class="fa fa-undo" aria-hidden="true"></i></span>
			<span title="Apply filters..." id="onSearchAccount" (click)="onSearch()"
				class="btn btn-primary btn-sm pull-right" style="margin-right: 6px !important;"><i class="fa fa-filter"
					aria-hidden="true"></i></span>
		</div>
	</div>
</fieldset>
<!-- <button title="Refresh Permit Applications" style="margin-top:-5px; color:black; background:white" class="btn btn-secondary btn-sm pull-left" (click)="loadAccounts()"><i class="fa fa-refresh" aria-hidden="true"></i></button> -->
<div class="table-responsive">
	<!-- <legend class="scheduler-border tsk-display blackcontrol">Carrier Accounts</legend> -->
	<table class="table table-sm custom_table">
		<thead class="thead-inverse">
			<tr class="hd-clpse">
				<th class="text-center">
					Lock status
				</th>
				<th>
					Account No
					<i class="fa fa-sort"
						[ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }"
						(click)="onSort(1)"></i>
				</th>
				<th>
					Account Id
					<i class="fa fa-sort"
						[ngClass]="{'fa-sort-asc sort-a': (flags.flagAI == 2),'fa-sort-desc sort-d': (flags.flagAI == 3), 'fa-sort':(flags.flagAI == 1) }"
						(click)="onSort(7)"></i>
				</th>
				<th>
					Account Name
					<i class="fa fa-sort"
						[ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }"
						(click)="onSort(2)"></i>
				</th>
				<th>
					Lead User
					<i class="fa fa-sort"
						[ngClass]="{'fa-sort-asc sort-a': (flags.flagLU == 2),'fa-sort-desc sort-d': (flags.flagLU == 3), 'fa-sort':(flags.flagLU == 1) }"
						(click)="onSort(3)"></i>
				</th>
				<th>
					Carrier Type
					<i class="fa fa-sort"
						[ngClass]="{'fa-sort-asc sort-a': (flags.flagCT == 2),'fa-sort-desc sort-d': (flags.flagCT == 3), 'fa-sort':(flags.flagCT == 1) }"
						(click)="onSort(4)"></i>
				</th>
				<th class="text-right">
					Submitted On
					<i class="fa fa-sort "
						[ngClass]="{'fa-sort-asc sort-a': (flags.flagDS == 2),'fa-sort-desc sort-d': (flags.flagDS == 3), 'fa-sort':(flags.flagDS == 1) }"
						(click)="onSort(6)"></i>
				</th>
				<th>
					Status
					<i class="fa fa-sort "
						[ngClass]="{'fa-sort-asc sort-a': (flags.flagST == 2),'fa-sort-desc sort-d': (flags.flagST == 3), 'fa-sort':(flags.flagST == 1) }"
						(click)="onSort(5)"></i>
				</th>
				<th class="text-center">
					Process Carrier Accounts
				</th>
			</tr>
		</thead>
		<tbody>
			<tr class="tbl-row" style="border-bottom: 1px solid #ddd;"
				*ngFor="let item of accounts | orderBy: criteria : direction | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count};let index = index">
				<!-- <td class="bfr-end-col">{{item.AccountNumber}}</td> -->
				<!-- <td><input type="checkbox" style="display: none;" value="{{item.id}}"
						[ngModel]="selectedIndex === index"
						(change)="CheckedCarrier($event,item.id,item,index)"></td> -->
				<td class="bfr-end-col text-center">
					<span *ngIf="item.isLocked==true" title="Locked by '{{item.isLockedBy}}', Click to unlock"
						style="margin: 0%" class="btn btn-md pull-center" (click)="unLockApplication(item)">
						<i class="fa fa-lock" aria-hidden="true" style="color: red;"></i>
					</span>
					<span *ngIf="item.isLocked==false || item.isLocked==undefined " title="Unlocked"
						style="margin: 0%" class="btn btn-md pull-center">
						<i class="fa fa-unlock" aria-hidden="true" style="color: green;"></i>
					</span>
				</td>
				<td class="bfr-end-col"><a [routerLink]="['/carrier/account/edit/' + item.Id + '/' + 1]"
						style="color:#00008b; text-decoration: underline;"><span
							title="View account details">{{item.AccountNumber}}</span></a></td>
				<td class="bfr-end-col">{{item.carrier_account_id}}</td>
				<td class="longtext bfr-end-col" title="{{item.Name}}">{{item.Name}}</td>
				<td class="bfr-end-col">{{item.LeadUser}}</td>
				<td class="bfr-end-col">{{item.CarrierType}}</td>
				<td class="bfr-end-col text-right">{{item.DateSubmitted?.toLocaleString() | date:'dd/MM/yyyy'}}</td>
				<td class="bfr-end-col">{{item.Status}}</td>
				<td class="bfr-end-col text-center">
					<span>
						<span title="View Carrier Account" class="btn btn-primary btn-sm pull-center myButton"
							style="display: none;" id="viewAcc" (click)="onViewAccount(selectedcarrier.Id)"><i
								class="fa fa-list" aria-hidden="true"></i></span>
						<span *ngIf="item.isLocked != true" title="Process Carrier Account" id="processAcc" style="margin-right:10px;"
							[ngClass]="{'disabled':item.status_id==1}"
							(click)="onProcess(selectedcarrier,item)">
							<img src="/assets/newimg/content-paste-1@2x.png" class="permit-view" />
						</span>

						<span *ngIf="item.isLocked == true && item.isLockedBy == currentUserName" style="margin-right:10px;"
							id="processAcc" title="Process Carrier Account"
							[ngClass]="{'disabled':item.status_id==1}"
							(click)="onProcess(selectedcarrier,item)">
							<img src="/assets/newimg/content-paste-1@2x.png" class="permit-view" />
						</span>

							<span style="margin-right:10px;"
								  id="viewAccHistory" title="View Account Permit History"
								 (click)="viewHistory(item)">
							<img src="/assets/newimg/visibility-16@2x.png" class="permit-view" />
						</span>

					</span>
				</td>
			</tr>
		</tbody>
		<tfoot>
			<tr *ngIf="count > 10" class="pagination_row">
				<td colspan="8">
					<div class="row">
						<div class="col-2">
							<div class="input-group mb-3 rm-brd"
								style="width:125px!important;height:30px!important;">
								<div class="input-group-prepend">
									<label class="input-group-text form-control-sm show-h"
										for="show-id">Show:</label>
								</div>
								<select class="form-control form-control-sm show-h" id="show-id"
									[(ngModel)]="pageSize" (change)="onChange()">
									<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
									</option>
								</select>
							</div>
						</div>
						<div class="col-10">
							<pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)"
								style="margin-left:0px!important;float: right !important;"></pagination-controls>
						</div>
					</div>
				</td>
			</tr>
			<tr *ngIf="isEmpty">
				<td colspan="4" class="rm-brd">
					<span class="text-info text-small">No carrier accounts found.</span>
				</td>
			</tr>
		</tfoot>
	</table>
	<p class="use-mouse">Use your mouse to hover over a code to see the description</p>
</div>
